import { ElementType, ForwardedRef, forwardRef, HTMLAttributes } from 'react'

interface BoxProps extends HTMLAttributes<HTMLElement> {
  component?: ElementType
  data_cy?: string
}

const Box = forwardRef(function Box(
  { component: Component = 'div', children, data_cy, ...props }: BoxProps,
  ref: ForwardedRef<HTMLElement>,
) {
  return (
    <Component ref={ref} data-cy={data_cy} {...props}>
      {children}
    </Component>
  )
})

export default Box
